import * as VueRouter from 'vue-router';

import API from './views/api/api.vue';
import Tokenization from './views/tokenization/tokenization.vue';
import GooglePay from './views/digital-wallet/google-pay.vue';
import ApplePay from './views/digital-wallet/apple-pay.vue';
import Webhooks from './views/webhooks/webhooks.vue';
import PGP from './views/pgp.vue';

const routes = [
  { path: '/', redirect: '/api/v2' },
  {
    path: '/api/:version',
    component: API,
    meta: {
      apiType: 'merchant',
    },
  },
  {
    path: '/api/iso/:version',
    component: API,
    meta: {
      apiType: 'iso',
    },
  },
  {
    path: '/tokenization',
    redirect: '/tokenization/v0.3',
  },
  {
    path: '/tokenization/:version',
    component: Tokenization,
    meta: { title: 'Tokenization', bulma: true },
  },
  { path: '/webhooks', redirect: '/webhooks/v1' },
  {
    path: '/webhooks/:version',
    component: Webhooks,
    meta: { title: 'Webhooks' },
  },
  // Backwards compatibility
  {
    path: '/google-pay',
    redirect: '/digital-wallet/google-pay',
  },
  {
    path: '/digital-wallet/google-pay',
    component: GooglePay,
    meta: { title: 'Google Pay', bulma: true },
  },
  {
    path: '/digital-wallet/apple-pay',
    component: ApplePay,
    meta: { title: 'Apple Pay', bulma: true },
  },
  {
    path: '/pgp-public-key',
    component: PGP,
    meta: { title: 'PGP Public Key', bulma: true },
  },
];

export const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes,
  scrollBehavior: function (to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    return to.hash
        // Scroll so the header isn't covered by the navbar
        ? { el: to.hash, top: 60 }
        : { left: 0, top: 0 };
  },
});

router.afterEach((to) => {
  if (to.meta.title) document.title = `${to.meta.title} - Gateway Documentation`;
});
